<template>
  <div class="results">
    <p
      v-if="props.includeResultNumber && isDesktop"
      class="results-number section-inner"
    >
      {{
        `${list.length} ${
          list.length == 1
            ? useMicroCopy("servicelocator.label.result")
            : useMicroCopy("servicelocator.label.results")
        }`
      }}
    </p>
    <div class="facility-cards section-inner">
      <FacilityCard
        v-for="(item, index) in pages[currentPage - 1]"
        :key="item.uid"
        :position="index"
        :facility="item"
        :include-facility-type-group-key="includeFacilityTypeGroupKey"
        :filters="filters"
        :size-hint="50"
        @mouseover="$emit('facilityCardMouseover', item)"
        @mouseleave="$emit('facilityCardMouseleave')"
      />
    </div>
    <GenericPagination
      v-show="pages.length > 1"
      :total-pages="pages.length"
      :current-page="currentPage"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  filters: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  includeFacilityTypeGroupKey: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  includeResultNumber: {
    type: Boolean,
    required: false,
    default: true,
  },
  enablePagination: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const isDesktop = inject("isDesktop");

const route = useRoute();

const itemsPerPage = 9;

const pages = computed(() => {
  if (props.enablePagination) {
    return Array.from(
      { length: Math.ceil(props.list.length / itemsPerPage) },
      (v, i) =>
        props.list.slice(i * itemsPerPage, i * itemsPerPage + itemsPerPage)
    );
  }
  return [props.list];
});

const currentPage = computed(() => {
  return typeof route.query.page !== "undefined"
    ? parseInt(route.query.page, 10)
    : 1;
});

defineEmits(["facilityCardMouseover", "facilityCardMouseleave"]);
</script>

<style lang="scss" scoped>
.facility {
  &-cards {
    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      minmax(min(100%, max(250px, 100%/4)), 1fr)
    );
    gap: 0.625rem;
  }
}
.results-number {
  font-weight: bold;
  margin-bottom: 0.75rem;
}
</style>
